
export default function useRcsAvailableSenders(senderKind, rcsMessagingServiceSid = null) {

    const configuredRcsSenders = window.ENV.RCS_SENDER_CONFIG || []
    const rcsSenderProfiles = window.ENV.RCS_SENDER_PROFILES || []
    
    const rcsSenders = configuredRcsSenders.filter(sender => sender.kind === senderKind).map(sender => ({
        messagingServiceSid: sender.twilio_messaging_service_sid,
        name: rcsSenderProfiles.find(profile => profile.messaging_service_sid === sender.twilio_messaging_service_sid)?.name,
        logoUrl: rcsSenderProfiles.find(profile => profile.messaging_service_sid === sender.twilio_messaging_service_sid)?.logo_url,
        kind: sender.kind,
        isDefault: sender.is_default
    })).sort((a, b) => a.isDefault === b.isDefault ? 0 : a.isDefault ? -1 : 1) // sort default senders first

    const selectedRcsSender = useMemo(() => {
        return rcsSenders.find(sender => sender.messagingServiceSid === rcsMessagingServiceSid) || rcsSenders.find(sender => sender.kind == senderKind && sender.isDefault) || null
    }, [rcsMessagingServiceSid, rcsSenders, senderKind])

    return [rcsSenders, selectedRcsSender]
}